<template>
  <div>
    <div class="mac-wrap">
      <div
        v-for="({ title, wages, jd, keyword, list }, key) in data"
        :key="key"
      >
        <div class="content-title">
          <div class="info">
            <p>{{ title }}</p>
            <ul>
              <li>{{ wages }}</li>
              <li>要求：{{ jd }}</li>
              <li v-if="keyword.length">关键词：{{ keyword.toString() }}</li>
            </ul>
          </div>
        </div>

        <div v-for="(item, index) in list" :key="index" class="content-box">
          <div class="section-title">
            {{ item.title }}
            <!-- <img
              v-if="key === active[0] && index === active[1]"
              src="~@/assets/arrow1.svg"
              alt=""
            />
            <img v-else src="~@/assets/arrow2.svg" alt="" /> -->
          </div>
          <div class="section-content">
            <div class="section-box">
              <div
                class="section-row"
                :class="{ 'row-empty': !items.list.length }"
                v-for="(items, idx) in item.data"
                :key="idx"
              >
                <div :class="['row-title']" v-if="items.title">
                  <span>{{ items.title }}</span>
                </div>

                <div
                  class="row-item"
                  :class="{ small: i.length > 20 }"
                  v-for="(i, d) in items.list"
                  :key="d"
                >
                  {{ i }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data () {
    return {
      active: [0, 1],
    }
  },
  methods: {
    toggle (item, key, index) {
      if (this.active[0] === key && this.active[1] === index) {
        this.active = [-1, -1]
        return
      }
      this.active = [key, index]
    }
  }
}
</script>

<style lang="scss" scoped>
.mac-wrap {
  margin: 0 auto;
  padding: 24px 24px 24px 24px;
  overflow: auto;
  text-transform: capitalize;
}
.content-box {
  position: relative;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  &.hover {
    .row-title,
    .section-title {
      cursor: pointer;
    }
  }
  &.highlight {
    .section-title {
      border-color: #ff7b00;
      color: #ff7b00;
    }
    .section-row {
      .row-title {
        background: #ff7b00;
        border-color: #ff7b00;

        & + .row-item {
          margin-top: 20px;
        }

        &::before,
        &::after {
          content: '';
          background-color: #ff7b00;
        }
      }
      &.row-empty .row-title::after {
        content: none;
      }
      .row-item {
        display: flex;
        height: 64px;
        min-height: 64px;
        border: 1px solid #979797;
        color: #1c1f21;
        margin-bottom: 8px;

        &.small {
          height: auto;
        }
      }
    }
  }

  .section-title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    width: 157px;
    height: 52px;
    border-radius: 8px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #6759bf;

    text-align: center;
    font-weight: 700;
    border: 2px solid #eaeaf7;
    margin-right: 70px;
    img {
      position: absolute;
      width: 38px;
      right: -54px;
    }
  }

  .section-content {
    margin-top: 12px;
    flex-grow: 1;
    width: 100%;
  }

  .section-box {
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
  }

  .trigger {
    position: absolute;
    font-size: 14px;
    color: #eaeaf7;
    z-index: 1;
    cursor: pointer;
    right: -40px;
    top: 16px;
  }
  .section-row {
    width: 46%;
    margin-right: 8%;
    margin-bottom: 12px;
    &:nth-child(2n - 1) .row-title::before {
      content: none;
    }
    &:nth-child(2n) {
      margin-right: 0;
    }

    .row-title {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 1;
      width: 100%;
      min-height: 52px;
      height: 100%;
      border-radius: 8px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5d4ebb;
      text-align: center;
      font-weight: 700;
      background: #eaeaf7;
      border-color: #eaeaf7;
      word-break: break-word;
      line-height: 16px;
      padding: 2px 12px;
      span {
        position: relative;
        z-index: 2;
      }
      &::before {
        display: block;
        content: '';
        position: absolute;
        top: 25px;
        left: -18%;
        right: 100%;
        height: 1px;
        background-color: #8b8bcc;
        z-index: -1;
      }
      &::after {
        display: block;
        position: absolute;
        width: 1px;
        height: 20px;
        top: 52px;
        background-color: #eaeaf7;
        z-index: -1;
      }
    }
    .row-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background: #fff;
      border-radius: 8px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      height: 0;
      color: transparent;
      overflow: hidden;
      transition: height 0.3s;
    }
  }
}

.item {
  &_index {
    font-size: 24px;
    font-weight: bold;
    color: #7979de;
    margin-top: 20px;
    position: relative;
    text-align: left;
    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 0px;
      height: 0px;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid #7979de;
      transform: rotate(-135deg);
      left: 27px;
      bottom: 9px;
    }
  }
}

h1 {
  color: #eaeaf7;
  font-weight: bold;
}
h4 {
  font-size: 18px;
  color: #48576a;
  margin-bottom: 75px;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 44px 0 0;
  text-align: left;
  justify-content: center;
  width: 100%;
  .info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 24px;
    p {
      font-size: 66px;
      color: #6455be;
      font-weight: 600;
      line-height: 66px;
      position: relative;
    }
    ul {
      width: 100%;
      text-align: center;
    }
  }
  .icon {
    position: relative;
    width: 20px;
    height: 20px;
    background: #6455be;
    transform: rotate(45deg);
    left: -45px;
    &::after,
    &::before {
      display: block;
      content: '';
      position: absolute;
    }
    &::after {
      width: 15px;
      height: 15px;
      background: rgba($color: #6455be, $alpha: 0.52);
      left: 15px;
      top: -10px;
    }
    &::before {
      width: 10px;
      height: 10px;
      background: rgba($color: #6455be, $alpha: 0.52);
      left: 15px;

      left: 30px;
      top: -20px;
    }
  }
}
</style>